export const domain = "https://www.sushivibe.com.tr"